import PropTypes from 'prop-types';
import CookieService from '../services/cookie-service';
import icon from '../images/document.png';
import './documents.scss';

const PdfDocuments = ({ documents }) => {
  if (!documents || documents.length < 0) return null;

  const AUTH_COOKIE = 'p1_jwt';
  const token = CookieService.getCookie(AUTH_COOKIE);

  return (
    <ul className="documents">
      { documents.map((document) => {
        const { title, file } = document;

        if (!title || !file) return null;

        return (
          <li key={title}>
            <a href={`${file}?token=${token}`} target="_blank" rel="noreferrer" download>
              {title}
              { icon && <img src={icon} alt={title} /> }
            </a>
          </li>
        );
      }) }
    </ul>
  );
};

PdfDocuments.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default PdfDocuments;
